import { useEffect, useState } from "react";
import { EnglishToPersian, PersianToEnglish } from "numeral-convert";
import ReportingMenu from "./ReportingMenu";
import ReportsBox from "./ReportsBox";
import UserInformationTable from "../../components/UserInformationTable";
import Pagination from "../../components/Pagination";
import { MyContext } from "../../context/myContext";
import { useDispatch, useSelector } from "react-redux";
import { getExcel } from "../common-states/commonStatesSlice";
import { getReportData, selectReportBodyArray } from "./reportSlice";

let moment = require("moment-jalaali");

const Reporting = () => {
  const headArray = [
    "تاریخ دریافت",
    "تاریخ تعیین تحویل آب",
    "راننده",
    "تاریخ اختصاص راننده",
    "تاریخ درخواست",
    "حجم آب",
    "منطقه",
    "شهر",
    "نام متقاضی",
    "نوع آب",
    "ردیف",
  ];
  const [selected, setSelected] = useState({
    waterType: "شرب و دام",
    filter: "همه",
    city: "",
    region: "",
  });
  const bodyArray = useSelector(selectReportBodyArray);

  moment().format("jYYYY/jM/jD");

  let today = new Date().toLocaleDateString("fa-IR");
  let oneWeekAgo = new Date();
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  oneWeekAgo = oneWeekAgo.toLocaleDateString("fa-IR");

  const [persianDate, setPersianDate] = useState({
    startDate: oneWeekAgo,
    endDate: today,
  });
  const [period, setPeriod] = useState("week");
  const dispatch = useDispatch();

  const handlePeriodChange = (e) => {
    setPeriod(e.target.value);
  };
  const handleStartDateChange = (timestamp, newDate) => {
    let persianNumbers = EnglishToPersian(newDate);
    setPersianDate({ ...persianDate, startDate: persianNumbers });
  };
  const handleEndDateChange = (timestamp, newDate) => {
    let persianNumbers = EnglishToPersian(newDate);
    setPersianDate({ ...persianDate, endDate: persianNumbers });
  };

  useEffect(() => {
    if (period === "week") {
      let oneWeekAgo = new Date();
      oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
      oneWeekAgo = oneWeekAgo.toLocaleDateString("fa-IR");
      setPersianDate({ startDate: oneWeekAgo, endDate: today });
    } else {
      let oneMonthAgo = new Date();
      oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
      oneMonthAgo = oneMonthAgo.toLocaleDateString("fa-IR");
      setPersianDate({ startDate: oneMonthAgo, endDate: today });
    }
    // eslint-disable-next-line
  }, [period]);

  function getReport(searchParam, filterStatus, pageNum = 1) {
    let englishStartDate = moment(
      PersianToEnglish(persianDate.startDate),
      "jYYYY/jM/jD",
    ).format("YYYY-M-D");
    let englishEndDate = moment(
      PersianToEnglish(persianDate.endDate),
      "jYYYY/jM/jD",
    ).format("YYYY-M-D");
    dispatch(
      getReportData({
        searchParam,
        filterStatus,
        pageNum,
        englishStartDate,
        englishEndDate,
        dispatch,
      }),
    );
  }

  const handleSearch = (searchParam, filterStatus) => {
    console.log("search", searchParam);
    if (filterStatus === "همه") {
      getReport(searchParam, false); //True or false to change part of url for api call
    } else if (filterStatus === "تحویل شده") {
      getReport(searchParam, true);
    }
  };

  const handleChangePage = (item) => {
    const searchParam =
      selected.city && !selected?.region
        ? `city_id=${selected.city}`
        : selected.region && !selected.city
          ? `region=${selected.region}`
          : selected.city && selected.region
            ? `region=${selected.region} & city_id=${selected.city}`
            : "";
    if (selected.filter === "همه") {
      getReport(searchParam, false, item);
    } else if (selected.filter === "تحویل شده") {
      getReport(searchParam, true, item);
    } else {
      getReport("", false, item);
    }
  };

  const handleGetExcel = (waterType, cityId) => {
    const data = {
      city_id: cityId === "" ? null : cityId,
      start_created_at: moment(
        PersianToEnglish(persianDate.startDate),
        "jYYYY/jM/jD",
      ).format("YYYY/M/D"),
      end_created_at: moment(
        PersianToEnglish(persianDate.endDate),
        "jYYYY/jM/jD",
      ).format("YYYY/M/D"),
      sheet_type: 3,
      water_type:
        waterType === "شرب و دام"
          ? null
          : waterType === "شرب انسان"
            ? "1"
            : "2",
      items: [
        { item: "row", col_name: "ردیف" },
        { item: "created_at", col_name: "تاریخ ثبت" },
        { item: "city_id", col_name: "شهر" },
        { item: "water_type", col_name: "نوع آب" },
        { item: "driver_id", col_name: "راننده" },
        { item: "nomad_id", col_name: "متقاضی" },
        { item: "settlement_status", col_name: "وضعیت تسویه" },
        { item: "driver_delivered_at", col_name: "زمان تایید راننده" },
        { item: "nomad_confirmed_at", col_name: "زمان تحویل عشایر" },
              { item: "description", col_name: "توضیحات" },

        { item: "is_rejected", col_name: "رد شده" },
      ],
    };
    dispatch(getExcel(data));
  };

  useEffect(() => {
    const searchParam =
      selected.city && !selected?.region
        ? `city_id=${selected.city}`
        : selected.region && !selected.city
          ? `region=${selected.region}`
          : selected.city && selected.region
            ? `region=${selected.region}&city_id=${selected.city}`
            : "";
    getReport(searchParam, false, 1);
    // eslint-disable-next-line
  }, [persianDate.startDate, persianDate.endDate]);

  return (
    <div className="reporting-section bg-white rounded-md p-2 sm:p-6">
      <ReportingMenu
        date={persianDate}
        period={period}
        handlePeriodChange={handlePeriodChange}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        handleSearch={handleSearch}
        handleGetExcel={handleGetExcel}
        selected={selected}
        setSelected={setSelected}
      />
      <ReportsBox />
      <MyContext.Provider value={{ headArray, bodyArray }}>
        <UserInformationTable />
      </MyContext.Provider>
      <Pagination handleChangePage={handleChangePage} />
    </div>
  );
};

export default Reporting;
